/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InfoList } from '../../models/info-list';

export interface GetDowntimeInfos$Params {
  workCenterId: number;
  downtimeId: number;
  approvalReportDate: string;
}

export function getDowntimeInfos(http: HttpClient, rootUrl: string, params: GetDowntimeInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<InfoList>> {
  const rb = new RequestBuilder(rootUrl, getDowntimeInfos.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('downtimeId', params.downtimeId, {});
    rb.path('approvalReportDate', params.approvalReportDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InfoList>;
    })
  );
}

getDowntimeInfos.PATH = '/api/v1/workCenter/{workCenterId}/approvals/{approvalReportDate}/downtimes/{downtimeId}/info';
